import React from 'react'
import { connect } from 'react-redux'
import { Body, Micro, Title } from '@vds/typography';

const ProgressBar = props => {

    const { appState, buildProductState, mainclass, lineSection, isMobile, isTablet, flowType, movesEligibility,moves_cust_opt, cust_opt_makechanges } = props;  

    let showNonSeamlessProgressBar= false;
    // const isMobile = (window.screen.width < 744) ? true : false;
    // const isTablet = (window.screen.width > 743 && window.screen.width < 1025) ? true : false;
    const checkQueryString  =  window?.location?.href?.includes('/inhome/popularPlans?lq2=y');     

    let mobileProgressLinks = (buildProductState?.isPopularPlan || window.location.pathname?.includes('popularPlans') || checkQueryString) ? ['Pick popular plan', 'Customize   ', 'Review       ', 'Checkout    '] :['Pick your plan', 'Review    ', 'Checkout    '];

    if(window.location.pathname?.includes('moves/landing') && flowType==='MV'){
        mobileProgressLinks =['Begin your move                 ', 'Checkout                 '];
    }
    
    if(flowType==='MV' && !window.location.pathname?.includes('moves/landing') && (moves_cust_opt==='NONSEAMLESS' || cust_opt_makechanges)){
        mobileProgressLinks =(buildProductState?.isPopularPlan || window.location.pathname?.includes('popularPlans') || checkQueryString) ? ['Begin your move','Pick your plan','Customize     ', 'Review    ', 'Checkout    ']:['Begin your move','Pick your plan', 'Review    ', 'Checkout    '];
        showNonSeamlessProgressBar= true;
    }
    
    let mobileParsedLinks = 0;
    if(window && window.location && window.location.pathname && (flowType!=='MV' || (!showNonSeamlessProgressBar))){
        if(window.location.pathname?.includes('buildproducts')){
            mobileParsedLinks = buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 1 : 0;
        }
        if(window.location.pathname?.includes('ordersummary')){
            mobileParsedLinks = buildProductState?.isRedirectionToPopular && buildProductState?.isPopularPlan ? 2 : 1;
        }
        if(window.location.pathname?.includes('checkout')){
            mobileParsedLinks = buildProductState?.isRedirectionToPopular && buildProductState?.isPopularPlan ? 3 : 2;
        }
    }
    else if(window && window.location && window.location.pathname && showNonSeamlessProgressBar){

        if(window.location.pathname?.includes('popularPlans')){
            mobileParsedLinks =  buildProductState?.isRedirectionToPopular ? 1 :0;
        }

        if(window.location.pathname?.includes('buildproducts')){
            mobileParsedLinks =  buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 2 :1;
        }
        if(window.location.pathname?.includes('ordersummary')){
            mobileParsedLinks =  buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 3 :2;
        }
        if(window.location.pathname?.includes('checkout')){
            mobileParsedLinks =   buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 4 :3;
        }
       
    }
    const mobileCurrentProgress = mobileProgressLinks[mobileParsedLinks];
    const mobileNextProgress = mobileProgressLinks[mobileParsedLinks + 1];
    const mobileTotalarr = mobileProgressLinks?.length;

    let mobileprogressbarTabClass = '';
    if(mobileProgressLinks.length === 5){
        mobileprogressbarTabClass = 'flex-item-progressbarfivetab';
    }else if(mobileProgressLinks.length === 4){
        mobileprogressbarTabClass = 'flex-item-progressbarfourtab';
    }
    else if(mobileProgressLinks.length === 3){
        mobileprogressbarTabClass = 'flex-item-progressbarthreetab';
    }
    else if(mobileProgressLinks.length === 2){
        mobileprogressbarTabClass = 'flex-item-progressbartwotab';
    }
    
        

    const mainTabletSubheader =  
        <> 
        <div id="fiosSubHeader" className={`${mainclass} bg-white` } >
            {isTablet &&
            <div className="appfbHeaderAlignment padding-top-tiny" style={{width: '100%'}}>
                {mobileProgressLinks.map((link, index) => {
                    return (<>
                    <div className="appfbFormAlign">
                        {index === 0 ?
                        <span style={{ textAlign: 'left', textWrap: 'nowrap' }}>
                            <Body size="small" color='#EE0000'>
                                {mobileCurrentProgress}
                            </Body>
                        </span>
                        : index === mobileProgressLinks.length - 1 && mobileNextProgress ?
                        <span style={{ textAlign: 'right' }}>
                            <Micro color='#A7A7A7' >
                                {!window.location.pathname?.includes('moves/landing') && 'Next:'} {mobileNextProgress}
                            </Micro>
                        </span>
                        : <span style={{ textAlign: 'right' }}>
                            <Micro color='#ffffff' >{link}</Micro>
                        </span>
                    }
                </div>
                </>)
                })}
            </div>}
            <div style={{display:'flex', width: '100%', flexDirection: 'row',justifyContent:'space-between', margin: '0 auto'}}>
                {mobileProgressLinks.map((link, index) => {
                    return (
                        <div className={mobileParsedLinks >= index ? ` activeProgressNC tabletProgressbarItem ${(index !=0 &&  index != mobileProgressLinks?.length - 1) ? 'tabletProgressbarMargin' : ''} ${mobileprogressbarTabClass}` : ` inactiveProgressNC tabletProgressbarItem tabletProgressbarMargin ${mobileprogressbarTabClass}`} cartindex={index} tabIndex={index} role="tab" aria-label={`step ${index + 1} of ${mobileTotalarr} ${link}`} aria-selected={mobileParsedLinks === index } key={index} />
                    )
                })}             
            </div>
        </div>
        </>            
    ;   

    const navProgressLinks = () => {
        
        let progressLinks = (buildProductState?.isPopularPlan || window.location.pathname?.includes('popularPlans') || checkQueryString) ? ['Pick popular plan', 'Customize   ', 'Review       ', 'Checkout    '] :['Pick your plan', 'Review    ', 'Checkout    '];

        if(window.location.pathname?.includes('moves/landing') && flowType==='MV'){
            progressLinks =['Begin your move                 ', 'Checkout                 '];
        }
        
        if(flowType==='MV' && !window.location.pathname?.includes('moves/landing') && (moves_cust_opt==='NONSEAMLESS' ||  cust_opt_makechanges)){
            progressLinks =(buildProductState?.isPopularPlan || window.location.pathname?.includes('popularPlans') || checkQueryString) ? ['Begin your move','Pick your plan','Customize     ', 'Review    ', 'Checkout    ']:['Begin your move','Pick your plan', 'Review    ', 'Checkout    ']
        }

        let parsedLinks = 0;        

        if((window && window.location && window.location.pathname && (flowType!=='MV' || (!showNonSeamlessProgressBar)))){
            if(window.location.pathname?.includes('buildproducts')){
                parsedLinks = buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 1 : 0;
            }
            if(window.location.pathname?.includes('ordersummary')){
                parsedLinks = buildProductState?.isRedirectionToPopular && buildProductState?.isPopularPlan ? 2 : 1;
            }
            if(window.location.pathname?.includes('checkout')){
                parsedLinks = buildProductState?.isRedirectionToPopular && buildProductState?.isPopularPlan ? 3 : 2;
            }
        }
        else if(window && window.location && window.location.pathname && showNonSeamlessProgressBar){
            
            if(window.location.pathname?.includes('popularPlans')){
                parsedLinks =  buildProductState?.isRedirectionToPopular ? 1 :0;
            }

            if(window.location.pathname?.includes('buildproducts')){
                parsedLinks =  buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 2 :1;
            }
            if(window.location.pathname?.includes('ordersummary')){
                parsedLinks =  buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 3 :2;
            }
            if(window.location.pathname?.includes('checkout')){
                parsedLinks =   buildProductState?.isRedirectionToPopular &&  buildProductState?.isPopularPlan ? 4 :3;
            }
           
        }

        const currentProgress = progressLinks[parsedLinks];
        const nextProgress = progressLinks[parsedLinks + 1];
        const totalarr = progressLinks.length;

        let progressbarTabClass = '';
        let progressbarMobileTabClass='';
        if(progressLinks.length === 5){
            progressbarTabClass = 'flex-item-progressbarfivetab';
            progressbarMobileTabClass ='progressfivetabs';
        }else if(progressLinks.length === 4){
             progressbarTabClass = 'flex-item-progressbarfourtab';
             progressbarMobileTabClass ='progressfourtabs';
        }
        else if(progressLinks.length === 3){
            progressbarTabClass = 'flex-item-progressbarthreetab';
            progressbarMobileTabClass ='progressthreetabs';
       }
       else if(progressLinks.length === 2){
            progressbarTabClass = 'flex-item-progressbartwotab';
            progressbarMobileTabClass ='progresstwotabs';
       }
        
        return !isMobile ? 
        <div className={`topnav_userlinks flex-container-progressbar mozprogressbar ${isTablet && 'marginRight10 width55 position-relative'}`} >
                        {isTablet ? mainTabletSubheader :
                         progressLinks.map((link, index) => {                       

                            return <div className={parsedLinks >= index ? ` activeProgressNC progressbarItem ${(index !=0 &&  index != progressLinks.length - 1)?'progressbarMargin':''} ${progressbarTabClass}` : ` inactiveProgressNC progressbarItem progressbarMargin ${progressbarTabClass}`} cartindex={index} tabIndex="-1" aria-label={`step ${index + 1} of ${totalarr} ${link} ${parsedLinks >= index ? 'completed' : 'not completed'}`} aria-selected={parsedLinks === index } key={index} >
                                
                                {isMobile ? 
                                    <div style={{width: 'auto'}}>
                                        { index === 0 ? 
                                            <span style={{ textAlign: 'left', textWrap: 'nowrap' }}>
                                                <Body size="small" color='#EE0000'>
                                                    {currentProgress}
                                                </Body>
                                            </span> : 
                                            // parsedLinks + 1 === index 
                                            index === progressLinks.length - 1 && nextProgress ?
                                            <span style={{ textAlign: 'right' }}>
                                                <Micro color='#A7A7A7'>
                                                    Next: {nextProgress}
                                                </Micro>
                                            </span>
                                            : <span style={{ textAlign: 'right' }}>
                                                <Micro color='#ffffff'>
                                                    {link}
                                                </Micro>
                                            </span>
                                        }
                                    </div>
                                    : (
                                    <div style={{textWrap: 'nowrap'}}>
                                        <Body size="small" color={parsedLinks >= index ? '#EE0000' : '#A7A7A7'} ariaLabel={`step ${index + 1} of ${totalarr} ${link} ${parsedLinks >= index ? 'completed' : 'not completed'}`}>
                                        <span className="sr-only">step {index + 1} of {totalarr} </span>{link}<span className="sr-only"> {parsedLinks >= index ? 'completed' : 'not completed'}</span>
                                        </Body>
                                    </div>
                                )}
                                
                            </div>;
                    })}
                    
                </div> : <>
                 {progressLinks.map((link, index) => (
                         <div className={parsedLinks >= index ? `activeProgressNC  ${(isMobile || isTablet) ? progressbarMobileTabClass:''}` : `inactiveProgressNC  ${(isMobile || isTablet) ? progressbarMobileTabClass: ''}`} cartindex={index} aria-selected="false" key={index} >
                             <div tabIndex={index} role="tab" aria-label={`step ${index + 1} of ${totalarr} ${link}`} aria-selected={parsedLinks === index} >
                             </div>
                         </div>
                ))}</>;


        
                
    }

    const mainMobileSubheader = () =>{
        return <> 
            <div className={`padding-top-zero m_ordering-page main ${isMobile? '' :'padding-bottom-zero'}`}>
                <div className="accordion_wrapper tiny-margin-top-zero  OvrallMrgnRskn" style={{display:'block'}}>                    
                    <div className="appfbHeaderAlignment padding-top-tiny" style={{width:'100%'}}>
                        {mobileProgressLinks.map((link, index) => {
                            return (
                                <div className="appfbFormAlign">
                                    {index === 0 ?
                                        <span style={{ textAlign: 'left', textWrap: 'nowrap' }}>
                                            <Body size="small" color='#EE0000'>
                                                {mobileCurrentProgress}
                                            </Body>
                                        </span> :
                                        index === mobileProgressLinks.length - 1 && mobileNextProgress ?
                                            <span style={{ textAlign: 'right' }}>
                                                <Micro color='#A7A7A7' > {!window.location.pathname?.includes('moves/landing') && 'Next:'}  {mobileNextProgress}</Micro>
                                            </span> : <span style={{ textAlign: 'right' }}><Micro color='#ffffff' >{link}</Micro></span>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    <div style={{display:'flex', width: '100%', flexDirection: 'row',justifyContent:'space-between', margin: '0 auto'}}>
                        {navProgressLinks()}                        
                    </div>
                    {lineSection ?? lineSection}                    
                </div>               
            </div>          
        </>;
    } 
    
    return (<>
        {
            !isMobile ? navProgressLinks() : mainMobileSubheader()
        }
    </>)

}

const mapStateToProps = state => {
    return {
      lqState: state.loopQual,
      appState: state.app, 
      cartState: state.cart,  
      buildProductState: state.buildProduct,         
      visitId: state.app.visitId,
    }
  }
  
  export default React.memo(connect(mapStateToProps)(ProgressBar));